<script>
import AxiosSelect from '@base-inputs/AxiosSelect';
import Api from '@helpers/api';

export default {
  name: 'CarClaimTypesSelect',
  extends: AxiosSelect,
  props: {
    clearable: {
      default: () => false
    },
    value: {},
    axiosUrl: {
      default: () => Api.methods.resources.carClaimTypes
    }
  },
  methods: {
    complete(data, request) {
      if (this.isCarCollector && Array.isArray(data)) {
        data = data.filter((item) => {
          const id = item && (item.id != null ? item.id : item.value);
          return Number(id) !== 3;
        });
      }
      return AxiosSelect.methods.complete.call(this, data, request);
    }
  }
};
</script>
